export default "__VITE_ASSET__ad285c0d__"